import React, { Component } from "react";
import {ControlLabel} from "react-bootstrap";
import {Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import getServerURL from "../../../../functions/getServerURL";
import AccessRequestForm from "./AccessRequestForm";


class DataSourceDropdown extends Component {
  state = {
    dataSources: [],
    selectedDataSource: [],
    fetchingDataSources: false
  }

  componentDidMount() {
    this.getDataSources()
  }

  getDataSources = () => {
    const { selectedClient } = this.props
    this.setState({ fetchingDataSources: true }, () => {
      axios.get(`${getServerURL()}access-request-data-sources/?client=${ selectedClient.id }`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({ dataSources: response.data })
      }).catch(error => {
        console.log(error, error.response)
      }).finally(() => {
        this.setState({ fetchingDataSources: false })
      })
    })
  }

  handleSelectDataSource = (selectedDataSource) => this.setState({ selectedDataSource })

  render() {
    const { selectedClient } = this.props
    const { dataSources, selectedDataSource, fetchingDataSources } = this.state

    return (
      <React.Fragment>
        { fetchingDataSources ?
          <center>
            <div id="not-found">
              <img alt="loader" src={require("../../../../static/images/spinner.gif")} />
            </div>
          </center>
          :
          <React.Fragment>
            <div className="form-input-container">
              <ControlLabel>
                Select Data Source
              </ControlLabel>
              <Typeahead
                style={{ margin: "25px" }}
                id='SelectDataSourceTypeahead'
                labelKey={ dataSource => `${dataSource.name}` }
                options={ dataSources }
                selected={ selectedDataSource }
                onChange={ this.handleSelectDataSource }
                placeholder="Select data source"
              />
            </div>
            { !!selectedDataSource.length &&
              <AccessRequestForm
                selectedClient={ selectedClient }
                selectedDataSource={ selectedDataSource[0] }
              />
            }
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}


export default DataSourceDropdown


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequest/components/DataSourceDropdown.js